import mutations from './mutations';
import actions from './actions';
import getters from './getters';
export const getDefaultState = () => {
    return {
        user: {},
        contacts: [],
        tenants: [],
        agent: {},
        borders: [],
        tenant_payload: {
            first_name: '',
            surname: '',
            ssn: ' ',
            position: '',
            phone_direct: '',
            phone_mobile: '',
            email: '',
            email_again: '',
            number_of_tenants: null,
            have_pets: false,
            is_smoker: false,
            furnished: null,
            min_number_of_rooms: null,
            min_sqm: null,
            desired_period: null,
            shortest_period: null,
            desired_move_in_date: '',
            max_rent: null,
            additional_requirements: '',
            border_ids: [],
            border_parentid: 0,
            configure_estate_property_residence_types_ids: null
        },
        viewings: {
            list: [],
            total: 0
        }
    };
};
export const state = getDefaultState();
export const company = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
